import React, {useState, useEffect} from 'react'
import '../styles/_index.scss'
import {Link} from "react-router-dom"
import {message, Button, Radio, Select, Tooltip} from "antd"
import getHistory from "../../../getHistory"
import { getShippingCarrier } from '../../../services/api/apiSettingShippingCarrier'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MultiInput from './templates/MultiInput'
import { getDetailSettingBoxes, updateSettingBoxes } from '../../../services/api/apiSettingBoxes'
import SettingBoxesHistory from './SettingBoxesHistory'

function EditSettingBoxes(props) {
    const [optionsSlugCarrier, setOptionsSlugCarrier] = useState([])
    const [boxType, setBoxType] = useState('combination')
    const [combinationBoxNameBefore, setCombinationBoxNameBefore] = useState('')
    const [combinationBoxName, setCombinationBoxName] = useState('')
    const [combinationBoxSlugBefore, setCombinationBoxSlugBefore] = useState([])
    const [combinationBoxSlug, setCombinationBoxSlug] = useState([])
    const [splitBoxSlugBefore, setSplitBoxSlugBefore] = useState('')
    const [splitBoxSlug, setSplitBoxSlug] = useState('')
    const defaultList = [
        {
            boxName: '',
            shippingLevel: '',
            sku: {
                type: 'accept',
                value: []
            },
            store: {
                type: 'accept',
                value: []
            },
            tag: {
                type: 'accept',
                value: []
            },
            state: {
                type: 'accept',
                value: []
            },
            country: {
                type: 'accept',
                value: []
            }
        }
    ];
    const [itemListBefore, setItemListBefore] = useState([]);
    const [itemList, setItemList] = useState(defaultList);

    const _fetchListOptionSlug = async () => {
        try {
            const payload = {
                page: 1,
                limit: 500
            }
            const {data, success} = await getShippingCarrier(payload)
            
            if (!success) {
                return
            }

            const listSlugCarriers = data.shippingCarriers.filter(item => item.box_type === 'Shipping box').map(item => item.slug).filter(item => !!item)
            
            const listOptions = listSlugCarriers.map(item => {
                return {
                    value: item,
                    name: item
                }
            })
        
            setOptionsSlugCarrier(listOptions)

        } catch (e) {
            message.error(e.message)
        }
    }

    async function _getDetailSettingBoxes() {
        try {
            const {match} = props
            const {setting_box_id} = match.params

            const {data: response} = await getDetailSettingBoxes(setting_box_id)

            const {success, message: error, data} = response

            if (!success) {
                return message.error(error)
            }
            
            setBoxType(data.type)
            if(data.type === 'combination'){
                setCombinationBoxNameBefore(data.box_name)
                setCombinationBoxName(data.box_name)
                setCombinationBoxSlugBefore(data.shipping_carriers)
                setCombinationBoxSlug(data.shipping_carriers)
            }

            if(data.type === 'split'){
                setSplitBoxSlugBefore(data.shipping_carriers[0])
                setSplitBoxSlug(data.shipping_carriers[0])

                const itemListData = data.boxes_data.map(box => {
                    const itemData = {
                        boxName: box.box_name,
                        shippingLevel: box.shipping_level === 50 ? 'first-class' : box.shipping_level === 60 ? 'priority' : '',
                        sku: {
                            type: box.sku.allow.length > 0 ?'accept' : box.sku.disallow.length > 0 ? 'except' : 'accept',
                            value: box.sku.allow.length > 0 ? box.sku.allow : box.sku.disallow.length > 0 ? box.sku.disallow : [],
                        },
                        store: {
                            type: box.store.allow.length > 0 ?'accept' : box.store.disallow.length > 0 ? 'except' : 'accept',
                            value: box.store.allow.length > 0 ? box.store.allow : box.store.disallow.length > 0 ? box.store.disallow : [],
                        },
                        tag: {
                            type: box.tag.allow.length > 0 ?'accept' : box.tag.disallow.length > 0 ? 'except' : 'accept',
                            value: box.tag.allow.length > 0 ? box.tag.allow : box.tag.disallow.length > 0 ? box.tag.disallow : [],
                        },
                        state: {
                            type: box.state.allow.length > 0 ?'accept' : box.state.disallow.length > 0 ? 'except' : 'accept',
                            value: box.state.allow.length > 0 ? box.state.allow : box.state.disallow.length > 0 ? box.state.disallow : [],
                        },
                        country: {
                            type: box.country.allow.length > 0 ?'accept' : box.country.disallow.length > 0 ? 'except' : 'accept',
                            value: box.country.allow.length > 0 ? box.country.allow : box.country.disallow.length > 0 ? box.country.disallow : [],
                        }
                    }

                    return itemData
                });

                setItemListBefore(JSON.parse(JSON.stringify(itemListData)))
                setItemList(itemListData)
            }
            
        } catch (e) {
            message.error(e.message)
        }
    }

    useEffect(() => {
        _fetchListOptionSlug()
        _getDetailSettingBoxes()
        // eslint-disable-next-line
    }, [])

    const  _handleChangeBoxType = (e) => {
        setBoxType(e.target.value)
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target

        if(name === 'boxName'){
            setCombinationBoxName(value)
        }
    }

    const _handleChangeSelect = (name, value) => {
        if(name === 'combinationBoxSlug'){
            setCombinationBoxSlug(value)
        }else if(name === 'splitBoxSlug'){
            setSplitBoxSlug(value)
        }
    }

    // Function to update list on drop
    const handleDrop = (droppedItem) => {
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;
        var updatedList = [...itemList];
        // Remove dragged item
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // Add dropped item
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        // Update State
        setItemList(updatedList);
    };

    const _handleChangeSplitBoxInput = (i, e) => {
        if(i !== -1){
            let newFormValues = [...itemList];
            newFormValues[i][e.target.name] = e.target.value;
            
            setItemList(newFormValues)
        }
    }

    const _handleChangeSplitBoxShippingLevel = (index, value) => {
        let newFormValues = [...itemList];
            newFormValues[index]['shippingLevel'] = value;

            setItemList(newFormValues)
    }

    const _handleChangeSplitBoxType = (name, index, value) => {
        let newFormValues = [...itemList];
        newFormValues[index][name]['type'] = value;
        setItemList(newFormValues)
    }

    const _handleChangeSplitBoxValue = (name, index, value) => {
        
        let newFormValues = [...itemList];
        newFormValues[index][name]['value'] = value;
        setItemList(newFormValues)
    }

    const insert = (arr, index, newItem) => [
        // part of the array before the specified index
        ...arr.slice(0, index),
        // inserted item
        newItem,
        // part of the array after the specified index
        ...arr.slice(index)
      ]

    const _handleAddNewBox = () => {
        
        const position = itemList.length - 1
        const newBox = {
                boxName: '',
                shippingLevel: '',
                sku: {
                    type: 'accept',
                    value: []
                },
                store: {
                    type: 'accept',
                    value: []
                },
                tag: {
                    type: 'accept',
                    value: []
                },
                state: {
                    type: 'accept',
                    value: []
                },
                country: {
                    type: 'accept',
                    value: []
                }
            }

        const newArray = insert([...itemList], position, newBox)
        setItemList(newArray)
    }

    const _handleRemoveItemForm = (index) => {
        const newFormArray = [...itemList]
        newFormArray.splice(index, 1)
        setItemList(newFormArray)
    }

    async function _handleUpdateSettingBoxes(data) {
        try {
            const {match} = props
            const {setting_box_id} = match.params

            const payload = {
                type: boxType
            }
            
            if(boxType === 'combination'){
                if(combinationBoxName) payload.box_name = combinationBoxName
                if(combinationBoxSlug.length > 0) payload.shipping_carriers = combinationBoxSlug
            }

            if(boxType === 'split'){
                if(splitBoxSlug) payload.shipping_carriers = [splitBoxSlug]
                const boxes_data = itemList.map((item, index) => {
                    const item_box = {
                        box_name: item.boxName,
                        // shipping_level: item.shippingLevel ? item.shippingLevel === 'priority' ? 60 : 50 : 0,
                        country: {
                            allow: item.country.type === 'accept' ? item.country.value : [],
                            disallow: item.country.type === 'except' ? item.country.value : []
                        },
                        state: {
                            allow: item.state.type === 'accept' ? item.state.value : [],
                            disallow: item.state.type === 'except' ? item.state.value : []
                        },
                        store: {
                            allow: item.store.type === 'accept' ? item.store.value : [],
                            disallow: item.store.type === 'except' ? item.store.value : []
                        },
                        sku: {
                            allow: item.sku.type === 'accept' ? item.sku.value : [],
                            disallow: item.sku.type === 'except' ? item.sku.value : []
                        },
                        tag: {
                            allow: item.tag.type === 'accept' ? item.tag.value : [],
                            disallow: item.tag.type === 'except' ? item.tag.value : []
                        },
                        priority: index + 1
                    }

                    if(item.shippingLevel){
                        if(item.shippingLevel === 'priority'){
                            item_box.shipping_level = 60
                        }else{
                            item_box.shipping_level = 50
                        }
                    }

                    return item_box
                })
                
                payload.boxes_data = boxes_data
            }

            const {data: response} = await updateSettingBoxes(setting_box_id, payload)

            const {success, message: error} = response

            if (!success) {
                return message.error(error)
            }

            const history = getHistory()
            history.push(`/setting-boxes`)

            message.success('Update setting boxes successfully!')
        } catch (e) {
            message.error(e.message)
        }
    }

    const handleCancel = () => {
        const history = getHistory()
        history.push(`/setting-boxes`)
    }

    const renderTextTooltip = (field, type) => {
        if(field === 'SKU'){
            if(type === 'accept'){
                return `Đơn chỉ chứa các SKU Accept` 
            }else{
                return `Đơn không chứa bất kì SKU Except nào`
            }
        }else if(field === 'Tag'){
            if(type === 'accept'){
                return `Đơn có tag nằm trong Tag Accept` 
            }else{
                return `Đơn không chứa bất kì Tag Except nào`
            }
        }
        
    }

    let disableButton = true
    if(boxType === 'combination' && (combinationBoxName !== combinationBoxNameBefore || JSON.stringify(combinationBoxSlug) !== JSON.stringify(combinationBoxSlugBefore))){
        disableButton = false
    } 

    if(boxType === 'split' && (JSON.stringify(splitBoxSlug) !== JSON.stringify(splitBoxSlugBefore) || JSON.stringify(itemList) !== JSON.stringify(itemListBefore))){
        disableButton = false
    }

    const {match} = props
    const {setting_box_id} = match.params

    return (
        <div className="NewSettingBoxesContainer">
            <div className="BackWrapper">
                <Link to='/setting-boxes'><i className='fa fa-chevron-left'/> Setting Boxes</Link>
            </div>

            <div className="TitlePage d-flex justify-content-between align-items-center">
                <h1>Edit box</h1>

                <div className='action'>
                    <Button className='btn-secondary ml-3' onClick={handleCancel}>
                        Cancel
                    </Button>

                    <Button className='btn-primary ml-3' onClick={_handleUpdateSettingBoxes} disabled={disableButton}>
                        Save
                    </Button>
                </div>
            </div>

            <div className="card NewSettingBoxes">
                <div className="card-body">
                    <div className="FormSettingBoxes">
                        <div className="boxType mb-3 ">
                            <Radio.Group onChange={_handleChangeBoxType} value={boxType} disabled>
                                <Radio value='combination'>Combination</Radio>
                                <Radio value='split'>Split box</Radio>
                            </Radio.Group>
                        </div>

                        {
                            boxType === 'combination' &&
                            <div className="CombinationField">
                                <div className="itemField mb-3 d-flex align-items-center">
                                    <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}>Box name</label>
                                    <div className="itemValue">
                                        <input
                                            name="boxName"
                                            className="ant-input"
                                            onChange={_handleChangeInput}
                                            value={combinationBoxName || ''}
                                            style={{width: 350}}
                                        />
                                    </div>
                                </div>

                                <div className="itemField mb-3 d-flex align-items-center">
                                    <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}>Slug</label>
                                    <div className="itemValue">
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{ width: '350px' }}
                                            placeholder=""
                                            filterOption={(input, option) => (option?.name.toLowerCase() ?? '').includes(input.toLowerCase())}
                                            onChange={value => _handleChangeSelect('combinationBoxSlug', value)}
                                            options={optionsSlugCarrier}
                                            value={combinationBoxSlug}
                                        />
                                    </div>

                                </div>
                            </div>
                        }

                        {
                            boxType === 'split' &&
                        <div className='splitBoxField'>
                            <div className="itemField mb-3 d-flex align-items-center">
                                <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}>Slug</label>
                                <div className="itemValue">
                                    <Select
                                        allowClear
                                        style={{ width: '350px' }}
                                        placeholder=""
                                        filterOption={(input, option) => (option?.name.toLowerCase() ?? '').includes(input.toLowerCase())}
                                        onChange={value => _handleChangeSelect('splitBoxSlug', value)}
                                        options={optionsSlugCarrier}
                                        value={splitBoxSlug || []}
                                    />
                                </div>
                            </div>

                            <div className="itemField mb-3">
                            <DragDropContext onDragEnd={handleDrop}>
                                <Droppable droppableId="list-container">
                                {(provided) => (
                                    <table className="setting-boxes-table">
                                        <thead>
                                            <tr>
                                                <th className="code" style={{width: 250}}>Box name</th>
                                                <th className="name">Condition</th>
                                                <th className="close" style={{width: 50}}></th>
                                            </tr>
                                        </thead>
                                        
                                        <tbody
                                        className="list-container"
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        >
                                        {itemList.map((item, index) => (
                                            <Draggable 
                                            key={index} 
                                            draggableId={`setting-box-${index}`} 
                                            index={index}
                                            >
                                            {(provided) => (
                                                <tr
                                                className={`item-container`}
                                                ref={provided.innerRef}
                                                {...provided.dragHandleProps}
                                                {...provided.draggableProps}
                                                >
                                                    <td style={{width: 250}}>
                                                        <div className=''>
                                                            <input
                                                                name="boxName"
                                                                className="ant-input"
                                                                onChange={e => _handleChangeSplitBoxInput(index, e)}
                                                                value={item.boxName || ''}
                                                                style={{width: 200}}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {/* <div className="container"> */}
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="itemField d-flex align-items-center">
                                                                        <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}>Shipping level</label>
                                                                        <div className="itemValue">
                                                                            <Select
                                                                                allowClear
                                                                                placeholder="Select shipping level"
                                                                                style={{width: 200}}
                                                                                onChange={value => _handleChangeSplitBoxShippingLevel(index, value)}
                                                                                options={[
                                                                                    {
                                                                                        value: 'priority',
                                                                                        label: 'Priority',
                                                                                    },
                                                                                    {
                                                                                        value: 'first-class',
                                                                                        label: 'First Class',
                                                                                    }
                                                                                ]}
                                                                                value={item.shippingLevel || undefined}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <div className="itemField d-flex align-items-center">
                                                                        <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}><Tooltip title={() => renderTextTooltip('SKU', item.sku.type)}><span>SKU</span></Tooltip></label>
                                                                        <div className="itemValue d-flex align-items-center">
                                                                            <Select
                                                                                style={{width: 110}}
                                                                                onChange={value => _handleChangeSplitBoxType('sku', index, value)}
                                                                                options={[
                                                                                    {
                                                                                        value: 'accept',
                                                                                        label: 'Accept',
                                                                                    },
                                                                                    {
                                                                                        value: 'except',
                                                                                        label: 'Except',
                                                                                    }
                                                                                ]}
                                                                                value={item.sku.type}
                                                                            />
                                                                            <MultiInput
                                                                                field='sku'
                                                                                index={index}
                                                                                value_first={item.sku.value}
                                                                                onChange={_handleChangeSplitBoxValue}
                                                                                // validateFirst={validate.countryAllow}
                                                                                // validateLast={validate.countryDisallow}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="itemField d-flex align-items-center">
                                                                        <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}>Store</label>
                                                                        <div className="itemValue d-flex align-items-center">
                                                                            <Select
                                                                                style={{width: 110}}
                                                                                onChange={value => _handleChangeSplitBoxType('store', index, value)}
                                                                                options={[
                                                                                    {
                                                                                        value: 'accept',
                                                                                        label: 'Accept',
                                                                                    },
                                                                                    {
                                                                                        value: 'except',
                                                                                        label: 'Except',
                                                                                    }
                                                                                ]}
                                                                                value={item.store.type}
                                                                            />
                                                                            <MultiInput
                                                                                field='store'
                                                                                index={index}
                                                                                value_first={item.store.value}
                                                                                onChange={_handleChangeSplitBoxValue}
                                                                                // validateFirst={validate.countryAllow}
                                                                                // validateLast={validate.countryDisallow}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="itemField d-flex align-items-center">
                                                                        <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}><Tooltip title={() => renderTextTooltip('Tag', item.tag.type)}><span>Tag</span></Tooltip></label>
                                                                        <div className="itemValue d-flex align-items-center">
                                                                            <Select
                                                                                style={{width: 110}}
                                                                                onChange={value => _handleChangeSplitBoxType('tag', index, value)}
                                                                                options={[
                                                                                    {
                                                                                        value: 'accept',
                                                                                        label: 'Accept',
                                                                                    },
                                                                                    {
                                                                                        value: 'except',
                                                                                        label: 'Except',
                                                                                    }
                                                                                ]}
                                                                                value={item.tag.type}
                                                                            />
                                                                            <MultiInput
                                                                                field='tag'
                                                                                index={index}
                                                                                value_first={item.tag.value}
                                                                                onChange={_handleChangeSplitBoxValue}
                                                                                // validateFirst={validate.countryAllow}
                                                                                // validateLast={validate.countryDisallow}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-6">
                                                                    <div className="itemField d-flex align-items-center">
                                                                        <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}>State</label>
                                                                        <div className="itemValue d-flex align-items-center">
                                                                            <Select
                                                                                style={{width: 110}}
                                                                                onChange={value => _handleChangeSplitBoxType('state', index, value)}
                                                                                options={[
                                                                                    {
                                                                                        value: 'accept',
                                                                                        label: 'Accept',
                                                                                    },
                                                                                    {
                                                                                        value: 'except',
                                                                                        label: 'Except',
                                                                                    }
                                                                                ]}
                                                                                value={item.state.type}
                                                                            />
                                                                            <MultiInput
                                                                                field='state'
                                                                                index={index}
                                                                                value_first={item.state.value}
                                                                                onChange={_handleChangeSplitBoxValue}
                                                                                // validateFirst={validate.countryAllow}
                                                                                // validateLast={validate.countryDisallow}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="itemField d-flex align-items-center">
                                                                        <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}>Country</label>
                                                                        <div className="itemValue d-flex align-items-center">
                                                                            <Select
                                                                                style={{width: 110}}
                                                                                onChange={value => _handleChangeSplitBoxType('country', index, value)}
                                                                                options={[
                                                                                    {
                                                                                        value: 'accept',
                                                                                        label: 'Accept',
                                                                                    },
                                                                                    {
                                                                                        value: 'except',
                                                                                        label: 'Except',
                                                                                    }
                                                                                ]}
                                                                                value={item.country.type}
                                                                            />
                                                                            <MultiInput
                                                                                field='country'
                                                                                index={index}
                                                                                value_first={item.country.value}
                                                                                onChange={_handleChangeSplitBoxValue}
                                                                                // validateFirst={validate.countryAllow}
                                                                                // validateLast={validate.countryDisallow}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        {/* </div> */}
                                                    </td>
                                                    <td style={{width: 50}}>
                                                        {
                                                            itemList.length > 1 ? <span className="remove-item" onClick={() => _handleRemoveItemForm(index)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <circle cx="12" cy="12" r="8.4" stroke="black" stroke-opacity="0.69" stroke-width="1.2"/>
                                                                <path d="M9 14.9995L15 8.99951" stroke="black" stroke-opacity="0.69" stroke-width="1.2"/>
                                                                <path d="M15 15L9 9" stroke="black" stroke-opacity="0.69" stroke-width="1.2"/>
                                                            </svg>
                                                        </span> : ''
                                                        }
                                                        
                                                    </td>
                                                {/* {item} */}
                                                </tr>
                                            )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                        </tbody>
                                    </table>
                                )}
                                </Droppable>
                            </DragDropContext>

                            <Button type="text" onClick={_handleAddNewBox} className="add-box">+ Add box</Button>
                            </div>
                        </div>
                        }

                    </div>
                </div>
            </div>

            <div className="card SettingBoxesHistory">
                <div className="card-body">
                    <SettingBoxesHistory settingBoxId={setting_box_id}/>
                </div>
            </div>
        </div>
    )
}

export default EditSettingBoxes